"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 2.02.21
 *
 */
var HoverTracker = /*#__PURE__*/function () {
  function HoverTracker(element) {
    var triggerDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2["default"])(this, HoverTracker);

    if (typeof triggerDelay === "function") {
      callback = triggerDelay;
      triggerDelay = 1000;
    }

    var elem = element;

    if (typeof element === "string") {
      elem = document.getElementById(element);
    }

    this.elem = elem;
    this.callback = callback;
    this.threasholdMs = triggerDelay;
    this.enterListener = this.mouseEnterTracker.bind(this);
    this.leaveListener = this.mouseLeaveTracker.bind(this); // console.log("HoverTracker = ", this)

    this.start();
  }

  (0, _createClass2["default"])(HoverTracker, [{
    key: "start",
    value: function start() {
      this.attachListeners();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.detachListeners();
    }
  }, {
    key: "attachListeners",
    value: function attachListeners() {
      if (this.elem) {
        this.elem.addEventListener("mouseenter", this.enterListener);
        this.elem.addEventListener("mouseleave", this.leaveListener);
      }
    }
  }, {
    key: "detachListeners",
    value: function detachListeners() {
      // console.log("detachListeners: elem = ", this.elem)
      if (this.elem) {
        this.elem.removeEventListener("mouseenter", this.enterListener);
        this.elem.removeEventListener("mouseleave", this.leaveListener);
      }
    }
  }, {
    key: "mouseEnterTracker",
    value: function mouseEnterTracker() {
      this.startMs = new Date().getTime(); // console.log("HoverTracker: mouseEnterTracker = ", this.startMs)
    }
  }, {
    key: "mouseLeaveTracker",
    value: function mouseLeaveTracker() {
      var endMs = new Date().getTime(); // console.log("HoverTracker: mouseLeaveTracker: endMs - this.startMs", endMs - this.startMs)

      if (endMs - this.startMs > this.threasholdMs) {
        // console.log("HoverTracker: fire callback")
        this.callback();
      }
    }
  }]);
  return HoverTracker;
}();

exports["default"] = HoverTracker;